import { connect } from 'react-redux';

import Screen from '../components/Screen';
import * as selectors from '../redux/selectors';

const mapStateToProps = (state: any) => ({
  ...selectors.selectChapterWindow(state).toJS(),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Screen);
